<script>
  const { jsPDF } = window.jspdf;
import { Router, Link, Route, link, navigate } from "svelte-routing";
import Header from "../components/header.svelte"
import Jouet from "../components/jouet.svelte"
import CardJouet from "../components/cardJouet.svelte"
import { isUserDbAdmin} from './stores.js';
import { get } from 'svelte/store';

export var db;
export var auth;

export let location;
  location = location;

const increment = firebase.firestore.FieldValue.increment(1);
const decrement = firebase.firestore.FieldValue.increment(-1);
function jincremente(a){
  return firebase.firestore.FieldValue.increment(a);
}
function jdecremente(a){
  return firebase.firestore.FieldValue.increment(-a);
}

var storedUser;
const unsubscribe = isUserDbAdmin.subscribe(value => {
		storedUser = value;
	});


var nom;
var jouets = [];
var is_Admin = false;
var req = 1;
var nbJouets = 0;
var prixTotal = 0;
var user = auth.currentUser;
var noInscrit = "";
var statut = "";
var rdv = ""
var emailVerfied;
let formnew;

var editID;


  function jaiVerif(){
    window.location.reload()
  }

/*
                 ------- Q R C O D E -------

var qrcode = new QRCode("qr_code", {
    text: "https://youtube.com",
    width: 128,
    height: 128,
    colorDark : "#000000",
    colorLight : "#ffffff",
    correctLevel : QRCode.CorrectLevel.H
});

*/

function getJouets(currentUid){
      jouets = []
  db.collection("jouets").where("owner_id", "==", currentUid).orderBy('creationDate')
  .onSnapshot((querySnapshot) => {
        //var jouets = [];
        querySnapshot.forEach((doc) => {
          let temp = doc.data()
          temp.id = doc.id;
          jouets = [...jouets,temp]
        });
    })
}




auth.onAuthStateChanged((user) => {
  if (user) {
    // User is signed in, see docs for a list of available properties
    // https://firebase.google.com/docs/reference/js/firebase.User
    var uid = user.uid;
    emailVerfied = auth.currentUser.emailVerified;
    db.collection("users").doc(uid).get().then((doc) => {
    if (doc.exists) {
        nom = doc.data().name;
        nom+=" "
        nom += doc.data().sirname;
        noInscrit = doc.data().noInscrit
        statut = doc.data().statut
        rdv = doc.data().rdv

        if(!storedUser){
          console.log("n'a pas été determiné si admin")
          db.collection("admins").doc(user.uid).get().then((doc) => {
            
            if (doc.exists) {
                  isUserDbAdmin.set({admin:true,name:doc.data().Nom});
                  is_Admin = true
              } else {
                  isUserDbAdmin.set({admin:false})
              }
          }).catch((error) => {
              console.log("Error getting document:", error);
          });;
        }

        if(storedUser.admin){
          is_Admin = true;
        }
        


        // On a recup le user - - - - - - - - - - - - - - - - - - - - - - - - 

        db.collection("jouets").where("owner_id", "==",auth.currentUser.uid).orderBy('creationDate')
        .onSnapshot((querySnapshot) => {
            jouets = [];
            
        querySnapshot.forEach((doc) => {
          let temp = doc.data()
          temp.id = doc.id;
          jouets = [...jouets,temp]
        });
        console.log('snapshot detected =>',jouets)
    })


    db.collection("users").doc(auth.currentUser.uid)
    .onSnapshot((doc) => {
        nbJouets = doc.data().nbJouets;
        prixTotal = doc.data().prixTotal;
    });

        // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
    }
}).catch((error) => {
    console.log("Error getting document:", error);
});
  } else {
    // User is signed out
    // ...
  }
});

function logout(){
  auth.signOut().then(() => {
    jouets = []
    user = undefined;
    navigate("/", { replace: false });
    window.location.reload()
}).catch((error) => {
  // An error happened.
});
}


function removeElement(array, elem) {
    var index = array.indexOf(elem);
    if (index > -1) {
        array.splice(index, 1);
        console.log('array apres supression',array)
				return array
    }
}


function goPanier(){
  navigate("/panier", { replace: false });
}
function goClients(){
  navigate("/clients", { replace: false });
}
function goJouets(){
  navigate("/jouets", { replace: false });
}
function goRdv(){
  navigate("/rdv", { replace: false });
}

function add_Jouet(currentUid){
  // Add a new document with a generated id.
db.collection("jouets").add({
    name: name,
    descriptif : descriptif,
    categorie:categorie,
    sub_categorie:sub_categorie,
    prix:prix,
    owner_id : currentUid,
    vendu: false,
    creationDate : new Date(),
    owner_name:nom,
    codeVendeur:noInscrit,
})
.then((docRef) => {
    console.log("Document written with ID: ", docRef.id);
    
    let userRef = db.collection('users').doc(currentUid);
   userRef.update({ nbJouets: increment,prixTotal: jincremente(prix) }).then(()=>{
    name = "";
    descriptif = "";
    prix = 0
    formnew.style.display = "none";

    //getJouets(auth.currentUser.uid)
   });
    
})
.catch((error) => {
    console.error("Error adding document: ", error);
    
});
}

var name;
var descriptif;
var categorie;
var sub_categorie;
var prix = 0;


function removeJouet(event){
  var id = event.detail.id
  let leJouet = event.detail.jouet
  console.log("delete",id)
  db.collection('jouets').doc(id).get().then((doc)=>{
    let userRef = db.collection('users').doc(auth.currentUser.uid);
   userRef.update({ nbJouets: decrement,prixTotal: jdecremente(doc.data().prix) }).then(()=>{
    jouets = []
    db.collection('jouets').doc(id).delete().then(()=>{
      
      console.log(jouets)
    })
});
   });
}

var modeModify = 'delete';

function editJouet(event){
  modeModify = 'modify';
  var id = event.detail.id
  editID = id;
  let leJouet = event.detail.jouet
  name = leJouet.name;
  descriptif = leJouet.descriptif;
  categorie = leJouet.categorie;
  sub_categorie = leJouet.sub_categorie;
  prix = leJouet.prix;
  formnew.style.display = "flex";
}

function editJouetGood(){
  console.log("edit",editID)
  db.collection('jouets').doc(editID).get().then((doc)=>{
  let data = doc.data();
  let userRef = db.collection('users').doc(auth.currentUser.uid);
   userRef.update({prixTotal: jdecremente(doc.data().prix) }).then(()=>{
    userRef.update({prixTotal: jincremente(prix) }).then(()=>{
      db.collection('jouets').doc(editID).update({
        name: name,
        descriptif: descriptif,
        categorie: categorie,
        sub_categorie: sub_categorie,
        prix: prix
      }).then(()=>{
          name = "";
          descriptif = "";
          categorie = "ACTIVITES MANUELLES";
          sub_categorie = "ARDOISE MAGIQUE";
          prix = 0;
          modeModify = 'delete';
          editID = "";
          formnew.style.display = "none"
          jouets = []
          window.location.reload();
      });


    });
    
  });
   });
}


let keyCode;
function handleKeydown(event) {
		/*keyCode = event.keyCode;
    if(keyCode==13 && name != "" && descriptif !="" && sub_categorie!="" && prix>0 && categorie!=""){
      if(modeModify == 'modify'){
        editJouetGood();
      }else{
        add_Jouet(auth.currentUser.uid)
      }
    }*/
	}

// H : 297 W : 210 (en a4)   Donc separation 3 en width et 74 en height


/*doc.text("Hello world!", 10, 10);
var text = 'https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=';
text += "https://youtube.com" 
doc.addImage(text, 'png', 20, 20, 50, 50);
doc.rect(100,0,2,10)
doc.rect(150,0,2,10)
doc.rect(200,0,2,10)
doc.rect(210,0,2,10)*/

var coordqr = []
var coordname = []
var coordprix = []
var coordrect = []
var coordno = []
var index = 0;

// COORDONNEE POUR LE QR

for(var j = 0;j<4;j++){
  for(var i=0;i<3;i++){
    coordqr.push([i*70+5,j*74+4])
  }
}

// COORDONNEE POUR LE Name

for(var j = 0;j<4;j++){
  for(var i=0;i<3;i++){
    coordname.push([i*70+5,j*74+55])
  }
}

// COORDONNEE POUR LE Prix

for(var j = 0;j<4;j++){
  for(var i=0;i<3;i++){
    coordprix.push([i*70+30,j*74+65])
  }
}

// COORDONNEE POUR Contour

for(var j = 0;j<4;j++){
  for(var i=0;i<3;i++){
    coordrect.push([i*70+2,j*74+2])
  }
}

// COORDONNEE POUR LE noInscrit

for(var j = 0;j<4;j++){
  for(var i=0;i<3;i++){
    coordno.push([i*70+5,j*74+65])
  }
}


var currentEtiquette = 0;


function makePDF(){
  index = 0;

    const doc = new jsPDF();
    jouets.forEach(element =>{
      currentEtiquette++;
      if(index>11){
        index = 0
        doc.addPage()
      }
      var qrco = 'https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=';
      qrco += element.id
      doc.addImage(qrco, 'png', coordqr[index][0], coordqr[index][1], 45, 45);
      doc.setFontSize(12)
      doc.text(element.name,coordname[index][0],coordname[index][1])
      doc.setFontSize(30)
      doc.text(element.prix+"€",coordprix[index][0],coordprix[index][1])
      doc.setFontSize(15)
      doc.text(element.codeVendeur,coordno[index][0],coordno[index][1])
      doc.roundedRect(coordrect[index][0],coordrect[index][1],55,70,5,5)
      index+=1;
      
    });
    doc.save("etiquettes.pdf")
    currentEtiquette = 0;



  
}

function finaliser(){
  statut = "pending"
  db.collection("users").doc(auth.currentUser.uid).update({
    statut: "pending"
})
}


/* Make list pdf*/

var listUser;

function makeListe(){
    user = auth.currentUser
    db.collection("users").doc(user.uid).get().then((doc) => {
    if (doc.exists) {
      listUser = doc.data()
    }

      const docL = new jsPDF();
      docL.rect(104,47, 2, 240, "F")
      docL.rect(0,10, 210, 1, "F")
      for(var i=0;i<21;i++){
        docL.rect(0,12*i+47, 210, 1, "F")
      }
      var don = listUser.don ? "OUI" : "NON"
      docL.text(listUser.sirname,5,20)
      docL.text(listUser.name,50,20)
      docL.text("Don : "+don,100,20)
      docL.text(listUser.noInscrit,165,20)
      docL.text(listUser.email,5,31)
      docL.text("Tel : " + listUser.tel,85,31)
      docL.text("RDV : "+listUser.rdv,140,31)
      docL.text("Participation : "+listUser.prixTotal*0.1.toFixed(2)+"€",5,42)
      docL.text("Total : "+listUser.prixTotal+"€",85,42)
      docL.text("Nombres d'articles : "+ listUser.nbJouets,140,42)
      
      var articlesUser = JSON.parse(JSON.stringify(jouets));
      

        console.log("articlesUser",articlesUser)
        articlesUser.forEach(jouet => {
          console.log(articlesUser.indexOf(jouet)<=19)
        if(articlesUser.indexOf(jouet)<=19){
          var x = 5
          var y = articlesUser.indexOf(jouet)*12+57
          docL.text((articlesUser.indexOf(jouet)+1) + ". " + jouet.name,x,y)
          x = 70
          docL.text("Prix : " + jouet.prix+"€",x,y)
        }else{
          var x = 110
          var y = (articlesUser.indexOf(jouet)-20)*12+57
          docL.text(jouet.name,x,y)
          x = 180
          docL.text("Prix : " + jouet.prix+"€",x,y)
        } 
      });
      docL.save(listUser.sirname)
    })
    .catch((error) => {
        console.log("Error getting documents: ", error);
    });
      

      
    }

/* FIn list pdf*/

    

    function showNew(){
        formnew.style.display = "flex";
    }

</script>

<svelte:window on:keydown={handleKeydown}/>

<main>
  <div id="qr_code">
  </div>
  <div class="cache"></div>
  <Header>
    <div on:click={logout} class="elm">Déconnexion</div>
    <div class="elm">Ma liste 📃</div>
    <div class="elm" on:click={goRdv}>RDV ⏰</div>
    {#if is_Admin}
    <div class="elm" on:click={goJouets}>Articles 🧸</div>
    <div class="elm" on:click={goClients}>Vendeurs 👱‍♂️</div>
    <div class="elm" on:click={goPanier}>Panier 🛒</div>
    {/if}
  </Header>
  {#if emailVerfied}
  {#if statut =="no" }
  <div class="container">
    <div class="contain_jouets">
      
      {#if jouets.length != 0}
      <div class="info">
        {#if !rdv}
        <div style="display: flex; margin-bottom:10px">
          <div class="submit" style="display: {jouets.length<40 ? "inline" : "none"};" on:click={showNew}>Nouvel article</div>
        <div class="submit-unvalid">Finaliser la liste</div>
        </div>
        
        <span style="height:fit-content;font-size: 1rem;font-family: 'Poppins', sans-serif;font-weight: 400;color:red;">• Pour finaliser votre liste, veuillez choisir une heure de rdv pour la dépose des articles.</span><br>
        <span style="height:fit-content;font-size: 1rem;font-family: 'Poppins', sans-serif;font-weight: 400;">• Nombre d'articles : {nbJouets}/40</span><br>
        <span style="height:fit-content;font-size: 1rem;font-family: 'Poppins', sans-serif;font-weight: 400;">• Montant total de la liste : {prixTotal}€</span>
         {:else}
         <div>
          <div class="submit" style="display: {jouets.length<40 ? "inline" : "none"};" on:click={showNew}>Nouvel article</div>
          <button class="submit" on:click={finaliser}>Finaliser la liste</button>
         </div>  
        <span style="height:fit-content;font-size: 1rem;font-family: 'Poppins', sans-serif;font-weight: 400;">• Nombre d'articles' : {nbJouets}/40</span><br>
        <span style="height:fit-content;font-size: 1rem;font-family: 'Poppins', sans-serif;font-weight: 400;">• Montant total de la liste : {prixTotal}€</span>
        {/if}
        
      </div>
      
      <div class="subcontain">
        {#each jouets as jouet}
        <Jouet {jouet} on:remove={removeJouet} on:edit={editJouet}></Jouet>
      {/each}
      </div>  
     
      {:else}
      <span style="height:fit-content;text-align: center;font-size: 2.5rem;font-family: 'Poppins', sans-serif;font-weight: 400;">⚠️ Vous n'avez aucun jouet dans votre liste ⚠️</span>
      <br>
      <br>
      <br>
      <div class="submit" style="display: {jouets.length<40 ? "inline" : "none"};" on:click={showNew}>Nouvel article</div>

      {/if}
    </div>






    
  </div>
  {#if jouets.length<40}
  <div bind:this={formnew} class="cacheform" on:click|self={formnew.style.display = "none"}>
  <div  class="formjouet">
    <h2 style="font-family: 'Poppins', sans-serif;font-weight: 400;font-size:clamp(1rem, -0.875rem + 2.4vw, 3.5rem);">Nouvel article 🧸</h2>
    <form>
      <select name="jouet" id="categorie" bind:value={categorie}>
        <option value="ACTIVITES MANUELLES">Activites Manuelles</option>
        <option value="AUDIO / VIDEO">Audio / Video</option>
        <option value="JEUX DE SOCIETE">Jeux De Societe</option>
        <option value="JEUX EDUCATIF">Jeux Educatif</option>
        <option value="JEUX INTERACTIF">Jeux Interactif</option>
        <option value="JEUX PLEIN AIR">Jeux Plein Air</option>
        <option value="JEUX D’IMITATION">Jeux D’Imitation</option>
        <option value="JOUET 1ER AGE">Jouet 1Er Age</option>
        <option value="JOUET EN BOIS">Jouet En Bois</option>
        <option value="LECTURE">Lecture</option>
        <option value="PUZZLE">Puzzle</option>
        <option value="UNIVERS BEBE">Univers Bebe</option>
        <option value="UNIVERS BEBE NUIT">Univers Bebe Nuit</option>
        <option value="UNIVERS BEBE REPAS">Univers Bebe Repas</option>
        <option value="UNIVERS FILLE">Univers Fille</option>
        <option value="UNIVERS GARCON">Univers Garcon</option>
        </select>

      {#if categorie == "ACTIVITES MANUELLES"}
      <select name="sub_categorie" id="sub_categorie" bind:value={sub_categorie}>
      <option value="ARDOISE MAGIQUE">Ardoise Magique</option>
      <option value="BIJOUX">Bijoux</option>
      <option value="COUTURE / CREATION">Couture / Creation</option>
      <option value="CUISINE">Cuisine</option>
      <option value="DECOUPAGE">Decoupage</option>
      <option value="FEUTRE / PEINTURE ">Feutre / Peinture </option>
      <option value="MANDALA">Mandala</option>
      <option value="MAQUETTE / TAMPON">Maquette / Tampon</option>
      <option value="PATE A MODELER ">Pate A Modeler </option>
      <option value="PERLE / BRODERIE">Perle / Broderie</option>
      <option value="PLAYMAIS">Playmais</option>
      <option value="POTERIE">Poterie</option>
      <option value="PROJECTEUR A DESSIN">Projecteur A Dessin</option>
      <option value="TABLEAU d’ACTIVITE">Tableau D’Activite</option>
      <option value="AUTRES">Autres</option>

      </select>

      {:else if categorie == "AUDIO / VIDEO"}
      <select name="sub_categorie" id="sub_categorie" bind:value={sub_categorie}>
      <option value="CASQUE ENFANT">Casque Enfant</option>
      <option value="DVD">Dvd</option>
      <option value="INSTRUMENT EN BOIS">Instrument En Bois</option>
      <option value="INSTRUMENTS">Instruments</option>
      <option value="LECTEUR MUSIQUE">Lecteur Musique</option>
      <option value="MICRO">Micro</option>
      <option value="AUTRES">Autres</option>
      </select>

      {:else if categorie == "JEUX DE SOCIETE"}
      <select name="sub_categorie" id="sub_categorie" bind:value={sub_categorie}>
      <option value="1ER AGE">1Er Age</option>
      <option value="CARTE à COLLECTION">Carte À Collection</option>
      <option value="CARTE à JOUER">Carte À Jouer</option>
      <option value="CLASSIQUE">Classique</option>
      <option value="ENIGME / STRATEGIE">Enigme / Strategie</option>
      <option value="EXPERIENCE / SCIENCE">Experience / Science</option>
      <option value="JUNIOR">Junior</option>
      <option value="LOTO / DOMINO / MEMORY">Loto / Domino / Memory</option>
      <option value="TV / AMBIANCE">Tv / Ambiance</option>
      <option value="VOYAGE">Voyage</option>
      <option value="AUTRES">Autres</option>
      </select>

      {:else if categorie == "JEUX EDUCATIF"}
      <select name="sub_categorie" id="sub_categorie" bind:value={sub_categorie}>
      <option value="BILINGUE">Bilingue</option>
      <option value="COMPTER">Compter</option>
      <option value="FORME / COULEUR">Forme / Couleur</option>
      <option value="HEURE / TEMPS">Heure / Temps</option>
      <option value="LETTRE / CHIFFRE">Lettre / Chiffre</option>
      <option value="LIRE / ECRIRE">Lire / Ecrire</option>
      <option value="AUTRES">Autres</option>
      </select>

      {:else if categorie == "JEUX INTERACTIF"}
      <select name="sub_categorie" id="sub_categorie" bind:value={sub_categorie}>
      <option value="ANIMAUX">Animaux</option>
      <option value="APPAREIL PHOTO">Appareil Photo</option>
      <option value="APPRENTISSAGE">Apprentissage</option>
      <option value="CONSOLE 1ER AGE">Console 1Er Age</option>
      <option value="LIVRE MUSICAL">Livre Musical</option>
      <option value="OBJET CONNECTE">Objet Connecte</option>
      <option value="ORDINATEUR ENFANT">Ordinateur Enfant</option>
      <option value="RADIOTELECOMMANDE">Radiotelecommande</option>
      <option value="TABLETTE ENFANT">Tablette Enfant</option>
      <option value="AUTRES">Autres</option>
      </select>

      {:else if categorie == "JEUX PLEIN AIR"}
      <select name="sub_categorie" id="sub_categorie" bind:value={sub_categorie}>
      <option value="BILLES">Billes</option>
      <option value="CASQUE / PROTECTION">Casque / Protection</option>
      <option value="DRAISIENNE">Draisienne</option>
      <option value="PLAGE">Plage</option>
      <option value="QUILLE / PETANQUE">Quille / Petanque</option>
      <option value="RAQUETTE">Raquette</option>
      <option value="ROLLER">Roller</option>
      <option value="SKATE BOARD">Skate Board</option>
      <option value="TALKIE WALKIE">Talkie Walkie</option>
      <option value="TENTE">Tente</option>
      <option value="TRICYCLE / MOTO">Tricycle / Moto</option>
      <option value="TROTINETTE">Trotinette</option>
      <option value="VELO">Velo</option>
      <option value="AUTRES">Autres</option>
      </select>

      {:else if categorie == "JEUX D’IMITATION"}
      <select name="sub_categorie" id="sub_categorie" bind:value={sub_categorie}>
      <option value="ACC DEGUISEMENT ">Acc Deguisement </option>
      <option value="BRICOLAGE / JARDINAGE">Bricolage / Jardinage</option>
      <option value="CAISSE / MARCHANDE">Caisse / Marchande</option>
      <option value="CUISINE / DINETTE">Cuisine / Dinette</option>
      <option value="DEGUISEMENT FILLE">Deguisement Fille</option>
      <option value="DEGUISEMENT GARCON">Deguisement Garcon</option>
      <option value="METIERS">Metiers</option>
      <option value="SOIN DE LA MAISON">Soin De La Maison</option>
      <option value="AUTRES">Autres</option>
      </select>

      {:else if categorie == "JOUET 1ER AGE"}
      <select name="sub_categorie" id="sub_categorie" bind:value={sub_categorie}>
      <option value="ANIMAUX">Animaux</option>
      <option value="BOITE à FORME">Boite À Forme</option>
      <option value="BRIQUE / CONSTRUCTION">Brique / Construction</option>
      <option value="CHARIOT DE MARCHE">Chariot De Marche</option>
      <option value="HOCHET">Hochet</option>
      <option value="JEU d’ACTIVITE / EVEIL">Jeu D’Activite / Eveil</option>
      <option value="JOUET SONORE">Jouet Sonore</option>
      <option value="LOT 1ER AGE">Lot 1Er Age</option>
      <option value="MR PATATE">Mr Patate</option>
      <option value="PERSONNAGE">Personnage</option>
      <option value="PLAYMOBIL 1 2 3 ">Playmobil 1 2 3 </option>
      <option value="TABLEAU d’ACTIVITE">Tableau D’Activite</option>
      <option value="TAPIS d’EVEIL">Tapis D’Eveil</option>
      <option value="VEHICULE">Vehicule</option>
      <option value="AUTRES">Autres</option>
      </select>


      {:else if categorie == "JOUET EN BOIS"}
      <select name="sub_categorie" id="sub_categorie" bind:value={sub_categorie}>
      <option value="ANIMAUX">Animaux</option>
      <option value="ANIMAUX à TIRER">Animaux À Tirer</option>
      <option value="BOULIER">Boulier</option>
      <option value="CUBE">Cube</option>
      <option value="JEU d’ACTIVITE / EVEIL">Jeu D’Activite / Eveil</option>
      <option value="KAPLA / CONSTRUCTION">Kapla / Construction</option>
      <option value="PECHE à la LIGNE">Peche À La Ligne</option>
      <option value="PUZZLE / ENCASTREMENT">Puzzle / Encastrement</option>
      <option value="TRAIN / CIRCUIT">Train / Circuit</option>
      <option value="VEHICULE">Vehicule</option>
      <option value="AUTRES">Autres</option>
      </select>

      {:else if categorie == "LECTURE"}
      <select name="sub_categorie" id="sub_categorie" bind:value={sub_categorie}>
      <option value="1ER AGE">1Er Age</option>
      <option value="1ERE LECTURE">1Ere Lecture</option>
      <option value="BD">Bd</option>
      <option value="CAHIER JEUX / EXERCICES">Cahier Jeux / Exercices</option>
      <option value="CUISINE ENFANTS">Cuisine Enfants</option>
      <option value="DICTIONNAIRE">Dictionnaire</option>
      <option value="DOCUMENTAIRE ">Documentaire </option>
      <option value="EDUCATIF">Educatif</option>
      <option value="LIVRE à ACTIVITER">Livre À Activiter</option>
      <option value="LIVRE DE CONTE">Livre De Conte</option>
      <option value="LIVRE PUZZLE">Livre Puzzle</option>
      <option value="LOT max 5 livres">Lot Max 5 Livres</option>
      <option value="PUERICULTURE">Puericulture</option>
      <option value="RECETTE BEBE">Recette Bebe</option>
      <option value="ROMAN">Roman</option>
      <option value="AUTRES">Autres</option>
      </select>

      {:else if categorie == "PUZZLE"}
      <select name="sub_categorie" id="sub_categorie" bind:value={sub_categorie}>
      <option value="LIVRE PUZZLE">Livre Puzzle</option>
      <option value="PUZZLE">Puzzle</option>
      <option value="PUZZLE ENFANT">Puzzle Enfant</option>
      <option value="PUZZLE 3D">Puzzle 3D</option>
      <option value="PUZZLE EN BOIS">Puzzle En Bois</option>
      <option value="AUTRES">Autres</option>
      </select>


      {:else if categorie == "UNIVERS BEBE"}
      <select name="sub_categorie" id="sub_categorie" bind:value={sub_categorie}>
      <option value="ACC POUSSETTE">Acc Poussette</option>
      <option value="ANNEAU DE BAIN ">Anneau De Bain </option>
      <option value="BAIGNOIRE ET ACC">Baignoire Et Acc</option>
      <option value="CHANCELIERE">Chanceliere</option>
      <option value="ECHARPE DE PORTAGE">Echarpe De Portage</option>
      <option value="PARC ET ACC">Parc Et Acc</option>
      <option value="PORTE BEBE">Porte Bebe</option>
      <option value="POUSETTE / NACELLE">Pousette / Nacelle</option>
      <option value="REHAUSSEUR">Rehausseur</option>
      <option value="SAC à LANGER">Sac À Langer</option>
      <option value="SIEGE AUTO">Siege Auto</option>
      <option value="TRANSAT / BALANCELLE">Transat / Balancelle</option>
      <option value="VOYAGE">Voyage</option>
      <option value="AUTRES">Autres</option>
      </select>

      {:else if categorie == "UNIVERS BEBE NUIT"}
      <select name="sub_categorie" id="sub_categorie" bind:value={sub_categorie}>
      <option value="BABYPHONE">Babyphone</option>
      <option value="BALANCE BEBE">Balance Bebe</option>
      <option value="BARIERE DE LIT / SECURITE">Bariere De Lit / Securite</option>
      <option value="CALE BEBE">Cale Bebe</option>
      <option value="GIGOTEUSE">Gigoteuse</option>
      <option value="LIT PARAPLUIE">Lit Parapluie</option>
      <option value="MATELAS">Matelas</option>
      <option value="MOBILE">Mobile</option>
      <option value="POT DE CHAMBRE">Pot De Chambre</option>
      <option value="TABLE à LANGER">Table À Langer</option>
      <option value="VEILLEUSE">Veilleuse</option>
      <option value="AUTRES">Autres</option>
      </select>

      {:else if categorie == "UNIVERS BEBE REPAS"}
      <select name="sub_categorie" id="sub_categorie" bind:value={sub_categorie}>
      <option value="BABYCOOK">Babycook</option>
      <option value="BIBERON / ACC">Biberon / Acc</option>
      <option value="CHAISE HAUTE">Chaise Haute</option>
      <option value="CHAUFFE BIBERON">Chauffe Biberon</option>
      <option value="COUSSIN ALLAITEMENT">Coussin Allaitement</option>
      <option value="EGOUTTOIR">Egouttoir</option>
      <option value="VAISELLE">Vaiselle</option>
      <option value="STERILISATEUR">Sterilisateur</option>
      <option value="AUTRES">Autres</option>
      </select>

      {:else if categorie == "UNIVERS FILLE"}
      <select name="sub_categorie" id="sub_categorie" bind:value={sub_categorie}>
      <option value="ACC POUPEE">Acc Poupee</option>
      <option value="ANIMAUX">Animaux</option>
      <option value="BARBIE / ACC">Barbie / Acc</option>
      <option value="BERCEAU / POUSSETTE">Berceau / Poussette</option>
      <option value="FIGURINE">Figurine</option>
      <option value="LEGO FRIENDS">Lego Friends</option>
      <option value="LOL SURPRISE">Lol Surprise</option>
      <option value="MAISON / ACC">Maison / Acc</option>
      <option value="NERF REBELLE">Nerf Rebelle</option>
      <option value="NURSERIE / ACC">Nurserie / Acc</option>
      <option value="PET SHOP">Pet Shop</option>
      <option value="PINYPON">Pinypon</option>
      <option value="POUPEE / POUPON">Poupee / Poupon</option>
      <option value="REINE DES NEIGES">Reine Des Neiges</option>
      <option value="ZHUZHU PET">Zhuzhu Pet</option>
      <option value="AUTRES">Autres</option>
      </select>

      {:else if categorie == "UNIVERS GARCON"}
      <select name="sub_categorie" id="sub_categorie" bind:value={sub_categorie}>
      <option value="ANIMAUX">Animaux</option>
      <option value="BEYBLADE">Beyblade</option>
      <option value="CIRCUIT">Circuit</option>
      <option value="CONSTRUCTION">Construction</option>
      <option value="FIGURINE">Figurine</option>
      <option value="GARAGE">Garage</option>
      <option value="HARRY POTTER">Harry Potter</option>
      <option value="LEGO">Lego</option>
      <option value="MECCANO">Meccano</option>
      <option value="NERF">Nerf</option>
      <option value="PLAYMOBIL">Playmobil</option>
      <option value="POKEMON">Pokemon</option>
      <option value="TRANSFORMERS">Transformers</option>
      <option value="VEHICULE">Vehicule</option>
      <option value="AUTRES">Autres</option>
      </select>


      {/if}
      <input type="text" class="inputt" maxlength="15" placeholder="Nom de l'article" bind:value={name}>
      <textarea type="text" rows="3" maxlength="50" cols="30" style='outline:none;color:white;width : 65%;border:none;border-bottom:3px solid white;resize:none;background-color: transparent;' placeholder="Bref descriptif" bind:value={descriptif}></textarea>
      <input type="number" class="inputt" min="0" placeholder="Prix" step=".5" bind:value={prix}>

      {#if modeModify == 'delete'}
      <div class="submit" on:click={()=>add_Jouet(auth.currentUser.uid)}>AJOUTER</div>
      {:else}
      <div class="submit" on:click={editJouetGood}>MODIFIER</div>
      {/if}
    </form>
  </div>
  </div>
  {/if}
    {:else if statut =="pending"}
    <div class="pending">
      Votre liste à été transmise à l'équipe de la bourse aux jouets pour vérification. <br> Vous recevrez un mail de confirmation afin de pouvoir imprimer la liste de vos étiquettes.
    </div>
    {:else if statut =="yes"}
    <div class="pdf" on:click={makeListe}>Générer ma liste</div>
    <div class="pdf" on:click={makePDF}>Générer mes étiquettes</div>
    {#if currentEtiquette}
        <span style="height:fit-content;font-size: 1rem;font-family: 'Poppins', sans-serif;font-weight: 400;">{currentEtiquette/nbJouets*100}%</span>
    {/if}
    <div class="valid-jouets">
      {#if jouets.length != 0}
      {#each jouets as jouet }
      <CardJouet {jouet} showVendu={false} proprio={false}></CardJouet>
      {/each}
      {/if}
    </div>
  {/if}

  {:else}
  <span style="height:fit-content;font-size: 1rem;font-family: 'Poppins', sans-serif;font-weight: 400;">Un email de vérification à été envoyé</span>
  <button on:click={jaiVerif}>J'ai vérifié mon adresse mail</button>
  {/if}
  
  

</main>

<style>
  
  main{
    width: 100vw;
    min-height: 100vh;
    background-color: #262626;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: white;
  }

    .cache{
      width: 100vw;
      height: 15vh;
    }

    .elm{ 
        color: white;
        margin-right: 20px;
        cursor: pointer;
        font-weight: 700;
    }

    .elm:hover{
        color: #507DBC ;
        text-decoration: none;
    }


    .formjouet{
      z-index: 10;
      height: 70vh;
      width: 20vw;
      background-color: #262626;
      box-shadow:  10px 10px 25px #151515,
         -10px -10px 25px #373737;
      border-radius: 20px;
      display: flex;
      flex-direction: column;
      right: 3vw;
      align-items: center;
      justify-content: space-evenly;
    }

    .container{
      display: flex;
      width: 100vw;
      height: fit-content;
    }

    .contain_jouets{
      width: 75vw;
      height: fit-content;
      padding:2.5vw;
    }

    .subcontain{
      width: 100vw;
      height: fit-content;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

    }
    .cacheform{
      width: 100vw;
      min-height: 100vh;
      position: fixed;
      top:0;
      left:0;
      background-color: rgba(0,0, 0, 0.6);
      display: none;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .inputt{
        padding: 10px;
        background-color: transparent;
        margin: 20px;
        height: 5vh;
        outline: none;
        border:none;
        border-bottom: 3px solid white;
        color: white;
        width : 65%;

    }

    form{
      display: flex;
         flex-direction: column;
         align-items: center;
         justify-content: space-around;
    }
    .submit{
      user-select: none;
        cursor: pointer;
        width: fit-content;
        height: fit-content;
        border-radius: 15px;
        color: white;
        font-size: 1.2rem;
        margin: 15px;
        font-weight: 400;
        padding: 15px;
        animation: glow 3s ease-in infinite;
        box-shadow: 0px 0px 30px -10px #7A9CCD;
        transition: ease-in-out .25s;
        user-select: none;
        font-family: 'Poppins', sans-serif;
        font-weight: 400;
        text-align: center;
        border: none;
    }
    .submit-unvalid{
      user-select: none;
        cursor: not-allowed;
        width: fit-content;
        height: fit-content;
        border-radius: 15px;
        color: white;
        font-size: 1.2rem;
        margin: 15px;
        font-weight: 400;
        padding: 15px;
        background-color: lightslategrey;
        box-shadow: 0px 0px 30px -10px #383838;
        transition: ease-in-out .25s;
        user-select: none;
        font-family: 'Poppins', sans-serif;
        font-weight: 400;
        text-align: center;
        border: none;
    }

    .pdf{
        width: fit-content;
        height: fit-content;
        border-radius: 15px;
        background-color: #507DBC;
        cursor: pointer;
        color: white;
        font-size: 1.5rem;
        margin: 10px;
        font-weight: 400;
        padding: 15px;
        animation: glow 3s ease-in infinite;
        box-shadow: 0px 0px 30px -10px #7A9CCD;
        transition: ease-in-out .25s;
        user-select: none;
        font-family: 'Poppins', sans-serif;
        font-weight: 400;
    }
    .pdf:hover{
        transform: scale(1.025);
    }

    .info{
      display: flex;
      justify-content: center;
      flex-direction: column;
    }

    @keyframes glow {
  0% {
    background: #507DBC;
  }
  25% {
    background: #6785af;
  }
  100% {
    background: #507DBC;
  }
}

.pending{
  width: 100%;
  height: 85vh;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  font-size: 1.5rem;
}

.valid-jouets{
  display: flex;
  width: 100vw;
  height:fit-content;
  flex-wrap: wrap;
  flex-direction: row;
}


@media (orientation:portrait){
  .cache{
    display: none;
  }
}
</style>
